import { httpClient } from '../httpClient';

/**
 * ON-13 License API endpoints.
 * GET  /api/license/status  — public status (rung, expiry, fingerprint)
 * POST /api/license/upload  — super-admin-only multipart upload
 */
export const licenseApi = {
  /**
   * Returns current license state.
   * Shape: { rung, expiry_date, days_left, entitled_modules,
   *          instance_fingerprint, heartbeat_result }
   */
  getStatus: () => httpClient.get('/license/status'),

  /**
   * Upload a new license file.
   * @param {File} file — the license.json file
   * @returns the new rung + status
   */
  uploadLicense: (file) => {
    const form = new FormData();
    // Field name MUST be 'license_file' — the backend reads
    // request.files.get('license_file') (modules/license/routes.py) and 400s on
    // anything else. Same name issue_license.py documents (curl -F license_file=@…).
    form.append('license_file', file);
    return httpClient.post('/license/upload', form, { isFormData: true });
  },
};
